import { css } from 'aphrodite';
import * as React from 'react';
import { getDisplayName } from '../../../../models/NameUtils';
import { Button } from '../../../../web/components-v2/Button';
import { OutcomePill } from '../../../components/OutcomePill';
import { ILeadServedOutcomeView } from '../../../viewModels/leads/interfaces';
import { CategoryPills } from './CategoryPills';
import { CompanyLink } from './CompanyLink';
import { RecordingCell } from './RecordingCell';
import { styleSheet } from './styles';

export const CALL_LOG_COLUMN_LABELS = ['Company', 'SDR', 'Time and outcome', 'Recording', 'Recording category'];

interface IProps {
	call: ILeadServedOutcomeView;
	canOpenSdrGoals: boolean;
	isSelected: boolean;
	onOpenCall: (callId: string, options?: { autoplay?: boolean }) => void;
	onOpenSdrGoals: (userId: string, userName: string) => void;
}

export const CallLogRow: React.FC<IProps> = ({ call, canOpenSdrGoals, isSelected, onOpenCall, onOpenSdrGoals }) => {
	const callId = call.phoneCall?.id;
	const companyName = call.company?.companyName || 'Unknown';
	const sdrName = getDisplayName(call.creator);

	return (
		<div
			className={css(styleSheet.row, styleSheet.callLogGrid, isSelected && styleSheet.rowSelected)}
			aria-current={isSelected || undefined}
		>
			{callId ? (
				<Button
					type='button'
					variant='ghost'
					aria-label={`View call details for ${companyName}`}
					styles={[styleSheet.openRow]}
					onClick={() => onOpenCall(callId)}
				/>
			) : null}
			<div className={css(styleSheet.company)}>
				<CompanyLink companyId={call.company?.id} companyName={call.company?.companyName} />
				<span className={css(styleSheet.mutedSmall)}>
					{call.company?.phoneNumbers?.[0]?.metadata?.standard || 'Unknown'}
				</span>
			</div>
			<div>
				{canOpenSdrGoals && call.creator?.id ? (
					<div className={css(styleSheet.aboveRow)}>
						<Button
							type='button'
							variant='link'
							size='sm'
							styles={[styleSheet.linkCell]}
							title={`Set coaching goals for ${sdrName}`}
							onClick={() => onOpenSdrGoals(call.creator.id, sdrName)}
						>
							{sdrName}
						</Button>
					</div>
				) : (
					<span>{sdrName}</span>
				)}
			</div>
			<OutcomePill interaction={call.interaction} />
			<RecordingCell phoneCall={call.phoneCall} onPlay={() => callId && onOpenCall(callId, { autoplay: true })} />
			{call.phoneCall?.categories?.length ? (
				<div className={css(styleSheet.categoryCell)}>
					<CategoryPills categories={call.phoneCall.categories} />
				</div>
			) : null}
		</div>
	);
};
